 <div class="row mt-5 justify-content-center">
    <div class="col-lg-8 col-md-10 col-sm-12">
        <div class="text-start">
            <h4 *ngIf="!showingOfficeSubjectObgligeds" class="fw-bold text-primary mb-3">Iniciar sesión</h4>
        </div>
        <form #loginForm="ngForm" *ngIf="!showingOfficeSubjectObgligeds" novalidate (ngSubmit)="onSubmit(loginForm.valid)">
            <ng-container *ngIf="!show2FAInput">
                <label for="username">Correo</label>
                <div class="input-group mb-3">
                    <span class="input-group-text"><i class="far fa-envelope"></i></span>
                    <input type="text" id="username" class="form-control" [(ngModel)]="user.username" name="username" #username="ngModel" [ngClass]="{'is-invalid': (!username.valid && formTouched), 'valid': (username.valid && formTouched)}" placeholder="Escribe tu correo electrónico" autocomplete="off"
                        required>
                </div>
                <label for="username">Contraseña</label>
                <div class="input-group mb-3">
                    <span class="input-group-text"><i class="fas fa-lock"></i></span>
                    <input type="password" id="password" class="form-control" [(ngModel)]="user.password" name="password" #password="ngModel" [ngClass]="{'is-invalid': (!password.valid && formTouched), 'valid': (password.valid && formTouched)}" placeholder="Escribe tu contraseña" autocomplete="off"
                    required>
                </div>
            </ng-container>
            <ng-container *ngIf="show2FAInput">
                <div class="form-floating">
                    Busca el código de seguridad de 6 dígitos en la aplicación <br /> <b>Microsoft Authenticator</b> e ingrésalo a continuación:
                </div>
                <div class="form-floating">
                    <input type="text" maxlength="6" id="mfaCode" class="form-control" [(ngModel)]="user.mfaCode" name="mfaCode" #mfaCode="ngModel" required [ngClass]="{'is-invalid': (!mfaCode.valid && formTouched), 'valid': (mfaCode.valid && formTouched)}" placeholder="-" autocomplete="off"
                        >
                    <label for="mfaCode">Código de seguridad</label>
                </div>
            </ng-container>
            <ng-container *ngIf="!show2FAInput">
                <div class="row d-flex justify-content-around mt-3 mb-5">
                    <div class="col">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" [disabled]="formSubmitted" [(ngModel)]="rememberMe" name="rememberMe"
                            class="form-check-input rounded-circle me-2" id="rememberMeCheck">
                            <label class="form-check-label" for="rememberMeCheck" style="vertical-align: middle;">Recuérdame</label>
                        </div>
                    </div>
                    <div class="col-8 text-right">
                        <a class="text-primary text-decoration-underline" [routerLink]="['/forgot-password']">¿Olvidaste tu contraseña?</a>
                    </div>
                </div>
            </ng-container>
            <div *ngIf="showLoginError">
                <div class="alert alert-warning">
                    No se logró iniciar sesi&oacute;n. Por favor verifica tus datos.
                </div>
            </div>
            <div *ngIf="isDisabledUser">
                <div class="alert alert-danger">
                    Su cuenta fue desactivada.
                </div>
            </div>
            <div class="d-grid gap-2 mt-4">
                <button type="submit" [disabled]="formSubmitted" class="btn btn-primary py-3 btn-block">Iniciar sesión</button>
            </div>
        </form>
    </div>
</div>